import React from 'react';

import { SaveToProjectMenu } from '@/components/projects/SaveToProjectMenu';
import { Button } from '@/components/ui/button';
import { InspectorHeader } from '@/components/ui/inspector/InspectorHeader';

interface RepurposeBodyProps {
  sourcePostId: string;
  onClose: () => void;
  backToProject?: { id: string; name: string; onReturn: () => void };
}

/**
 * RepurposeBody — minimal placeholder until the real workbench lands in
 * PR 6. v5 contract: 1-line header, no eyebrow, primary CTA on the right.
 *
 * The real implementation will consume the unified-media-studio archetype
 * (asset preview on left, edit rail with chips + composer on right). For
 * now we ship a low-fi shell so the Inspector dispatcher has a real body
 * to mount.
 */
export const RepurposeBody: React.FC<RepurposeBodyProps> = ({
  sourcePostId,
  onClose,
  backToProject,
}) => {
  return (
    <div className="flex h-full max-h-[80vh] flex-col">
      <InspectorHeader
        title="Repurpose post"
        onClose={onClose}
        backToProject={backToProject}
        meta={<span className="text-detail text-muted-foreground/80">Coming soon</span>}
        className="border-b border-border/40"
      />

      <div className="flex-1 overflow-y-auto px-4 py-6">
        <p className="text-detail leading-relaxed text-muted-foreground">
          The repurpose workbench will surface 1-source → N-variants generation here. Source post
          ID: <span className="font-mono text-foreground/85">{sourcePostId}</span>
        </p>
      </div>

      {/* TOOLBAR — v5 contract: icon cluster left, primary CTA right */}
      <div className="flex items-center justify-between gap-2 border-t border-border/60 bg-background/60 px-3 py-2">
        <div className="flex items-center gap-0.5">
          {!backToProject ? <SaveToProjectMenu artifactId={sourcePostId} /> : null}
        </div>
        <Button size="sm" variant="neutral" disabled>
          Generate variants
        </Button>
      </div>
    </div>
  );
};
